import type { StoreImage } from '../types';

/** Prefer full-resolution asset URLs — thumbnails often 404 while assets remain available. */
export function resolveEvidenceImageUrl(image: Pick<StoreImage, 'url'> & { assetUrl?: string | null }): string {
  const assetUrl = 'assetUrl' in image ? image.assetUrl : undefined;
  if (assetUrl && assetUrl.trim()) return assetUrl;
  return image.url?.trim() ?? '';
}

export function resolveEvidenceDisplayUrl(
  url: string | null | undefined,
  fallbackUrl?: string | null,
): string {
  if (url && url.trim()) return url;
  if (fallbackUrl && fallbackUrl.trim()) return fallbackUrl;
  return '';
}
